module.exports = __webpack_public_path__ + "images/skewness-13-desktop.png";